import { render, staticRenderFns } from "./NotesReadOnlyView.vue?vue&type=template&id=6f6126f2&scoped=true"
import script from "./NotesReadOnlyView.vue?vue&type=script&lang=js"
export * from "./NotesReadOnlyView.vue?vue&type=script&lang=js"
import style0 from "./NotesReadOnlyView.vue?vue&type=style&index=0&id=6f6126f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6126f2",
  null
  
)

export default component.exports